module.exports = __webpack_public_path__ + "static/mit_medialab_r-78f5098c5642f295e50f25f9bcee7dcb.png";